// -----------------------------------
// Disable/Enable Scroll
// -----------------------------------
function docDisableScroll() {
	var html = document.documentElement;
	html.classList.add('stop-scrolling');
	// var top = (window.pageYOffset || html.scrollTop) - (html.clientTop || 0);
	// window.scrollTopCache = top;
	// html.style.cssText += 'position: fixed; width: 100%; overflow-y: hidden; top:-' + top + 'px;';
}

function docEnableScroll() {
	var html = document.documentElement;
	html.classList.remove('stop-scrolling');
	// html.style.cssText = '';
	// window.scrollTo(0, window.scrollTopCache);
	// window.scrollTopCache = 0;
}

/**
 * Behaves the same as clearInterval except uses cancelRequestAnimationFrame() where possible for better performance
 * @param {int|object} fn The callback function
 */
// Stop Bug: https://stackoverflow.com/a/40296273
window.clearRequestInterval = function (handle) {
	window.cancelAnimationFrame
		? window.cancelAnimationFrame(handle.value)
		: window.webkitCancelAnimationFrame
		? window.webkitCancelAnimationFrame(handle.value)
		: window.webkitCancelRequestAnimationFrame
		? window.webkitCancelRequestAnimationFrame(handle.value) /* Support for legacy API */
		: window.mozCancelRequestAnimationFrame
		? window.mozCancelRequestAnimationFrame(handle.value)
		: window.oCancelRequestAnimationFrame
		? window.oCancelRequestAnimationFrame(handle.value)
		: window.msCancelRequestAnimationFrame
		? window.msCancelRequestAnimationFrame(handle.value)
		: clearInterval(handle);
};
/**
 * Behaves the same as setTimeout except uses requestAnimationFrame() where possible for better performance
 * @param {function} fn The callback function
 * @param {int} delay The delay in milliseconds
 */

window.requestTimeout = function (fn, delay) {
	if (
		!window.requestAnimationFrame &&
		!window.webkitRequestAnimationFrame &&
		!(window.mozRequestAnimationFrame && window.mozCancelRequestAnimationFrame) && // Firefox 5 ships without cancel support
		!window.oRequestAnimationFrame &&
		!window.msRequestAnimationFrame
	)
		return window.setTimeout(fn, delay);

	var start = new Date().getTime();
	var handle = new Object();

	function loop() {
		var current = new Date().getTime();
		var delta = current - start;

		delta >= delay ? fn.call() : (handle.value = requestAnimFrame(loop));
	}

	handle.value = requestAnimFrame(loop);
	return handle;
};

// https://www.cnblogs.com/coco1s/p/5499469.html
// 簡單的節流函數
window.throttle = function (func, wait, mustRun) {
	let timeout;
	let startTime = new Date();

	return function () {
		const context = this;
		const args = arguments;
		const curTime = new Date();

		clearTimeout(timeout);
		// 如果达到了规定的触发时间间隔，触发 handler
		if (curTime - startTime >= mustRun) {
			func.apply(context, args);
			startTime = curTime;
			// 没达到触发间隔，重新设定定时器
		} else {
			timeout = setTimeout(func, wait);
		}
	};
};

// -----------------------------------
// IE old version tip
// -----------------------------------
var userAgent = window.navigator.userAgent;
var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

if (
	userAgent.indexOf('MSIE 7.0') > 0 ||
	userAgent.indexOf('MSIE 8.0') > 0 ||
	userAgent.indexOf('MSIE 9.0') > 0 ||
	navigator.appVersion.indexOf('MSIE 10') !== -1
) {
	var url = 'browser.html';
	setTimeout(function () {
		$(location).attr('href', url);
	}, 0);
}

// -----------------------------------
// doc ready
// -----------------------------------
(function ($, window, document) {
	// Window 相關設定
	const w = window;
	const win = $(window);
	let ww, wh, ws;

	// 取得Window設定值
	function windowSetting() {
		ww = win.innerWidth();
		wh = win.innerHeight();
		ws = win.scrollTop();
	}

	// ----------------------------------- Window 相關監測
	// window on scroll use javascript
	// Reference: https://stackoverflow.com/a/10915048
	// http://dev.w3.org/2006/webapi/DOM-Level-3-Events/html/DOM3-Events.html#event-type-scroll
	function onScrollEventHandler(ev) {}
	function onResizeEventHandler(ev) {
		windowSetting();
	}
	function onLoadEventHandler(ev) {
		windowSetting();
		$(document).foundation();

		// Lazyload
		var lazyLoadInstance = new LazyLoad();
	}

	window.addEventListener('load', onLoadEventHandler);
	window.addEventListener('resize', throttle(onResizeEventHandler, 50, 100));
	window.addEventListener('scroll', throttle(onScrollEventHandler, 50, 100));

	// =================================================
	// 選單開啟關閉(Header 產品選單)
	$(document).on('click', '.js-expand-hd-menu', function (param) {
		const $el = $('.hd-menu-icon');
		const $header = $('#header');
		const $menu = $('.hd-main-block');

		if ($(window).scrollTop() <= $('#header').height()) {
			$('html, body').stop().animate({ scrollTop: 0 }, 0);
		}

		if (win.innerWidth() < 960) {
			if ($el.hasClass('is-open')) {
				$el.removeClass('is-open');
				$menu.removeClass('is-open');
				$header.removeClass('is-open');
				docEnableScroll();
			} else {
				$el.addClass('is-open');
				$menu.addClass('is-open');
				$header.addClass('is-open');
				docDisableScroll();
			}
		}
	});
	// 選單開啟關閉(Header 產品選單)
	// =================================================

	// =================================================
	// 選單開啟關閉(Footer Sitemap)
	$(document).on('click', '.js-expand-ft-sitemap', function (param) {
		const $el = $(this).parent('.ft-sitemap');
		// const $list = $(this).next('.ft-sitemap__list');

		if (win.innerWidth() < 960) {
			if ($el.hasClass('is-open')) {
				$el.removeClass('is-open');
				// $list.stop().slideUp(300);
			} else {
				$el.addClass('is-open');
				// $list.stop().slideDown(300);
			}
		}
	});
	// =================================================

	// =================================================
	// 下滑頁首變色
	$(window).on('scroll load', function () {
		let color;

		if ($('#header').hasClass('hd-bg-black')) {
			color = '#121215';
		}

		if ($('#header').hasClass('hd-bg-white')) {
			color = '#ffffff';
		}

		const ws = $(window).scrollTop();
		const colorOpacity = ws <= 300 ? ws / 300 : 1;

		var rgbaCol =
			'rgba(' +
			parseInt(color.slice(-6, -4), 16) +
			',' +
			parseInt(color.slice(-4, -2), 16) +
			',' +
			parseInt(color.slice(-2), 16) +
			',' +
			colorOpacity +
			')';

		$('#header').css('background-color', rgbaCol);
	});
	// =================================================

	/* ---------------------------------------- [START] ScrollTriggerAni */
	// 有滑動到該區增加動態者增加class "js-ani" ， 滑動到該區增加class "is-animated"
	let aniSec = document.querySelectorAll('.js-ani');
	const scrollTriggerAniThrottle = throttle(scrollTriggerAni, 200, 500); // 節流作用

	function scrollTriggerAni() {
		for (var i = 0; i < aniSec.length; i++) {
			if (isInViewport(aniSec[i])) {
				aniSec[i].classList.add('is-animated');
			}
		}

		cleanTrigger();

		/* If load all of the item, stop Listener */
		if (aniSec.length === 0) {
			window.addEventListener('scroll', scrollTriggerAniThrottle);
		}
	}

	function cleanTrigger() {
		aniSec = Array.prototype.filter.call(aniSec, function (ani) {
			return !ani.classList.contains('is-animated');
		});
	}

	function isInViewport(el) {
		const rect = el.getBoundingClientRect();
		const isVisible = el.offsetHeight !== 0;

		return (
			isVisible &&
			rect.bottom >= 0 &&
			rect.right >= 0 &&
			rect.top + 100 <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.left <= (window.innerWidth || document.documentElement.clientWidth)
		);
	}

	window.addEventListener('load', scrollTriggerAni);
	window.addEventListener('scroll', scrollTriggerAniThrottle);
	/* ---------------------------------------- [END] ScrollTriggerAni */

	// =================================================
	// https://www.cnblogs.com/coco1s/p/5499469.html
	// 簡單的節流函數
	function throttle(func, wait, mustRun) {
		let timeout;
		let startTime = new Date();

		return function () {
			const context = this;
			const args = arguments;
			const curTime = new Date();

			clearTimeout(timeout);
			// 如果达到了规定的触发时间间隔，触发 handler
			if (curTime - startTime >= mustRun) {
				func.apply(context, args);
				startTime = curTime;
				// 没达到触发间隔，重新设定定时器
			} else {
				timeout = setTimeout(func, wait);
			}
		};
	}
	// =================================================

	// =================================================
	// Reveal align middle
	// 示意開啟 modal
	let openModalId = '';

	$(document).on('click', '[data-modal-open]', function () {
		openModalId = $(this).attr('data-modal-open');

		$('#' + openModalId).addClass('is-active');
		docDisableScroll();
	});

	// 示意關閉 modal
	$(document).on('click', '[data-modal-close]', function () {
		$('#' + openModalId).removeClass('is-active');
		docEnableScroll();

		openModalId = '';
	});

	// w.addEventListener('resize', throttle(setRevealAlignMiddle, 50, 100));

	// =================================================

	// =================================================
	// 車子點擊換色
	$(document).on('click', '[data-cover-id]', function () {
		const $wrap = $(this).parents('.ride-card');
		const coverId = $(this).attr('data-cover-id');
		const $cover = $wrap.find('#' + coverId);
		const $allCover = $wrap.find('.ride-card__cover-img');

		const $box = $(this).parent('.palette-list');

		if (!$cover.attr('data-loaded')) {
			$cover.attr('src', $cover.attr('data-src'));
			$cover.attr('data-loaded', '');
		}

		// active
		$box.find('[data-cover-id]').removeClass('is-selected');
		$(this).addClass('is-selected');

		$allCover.removeClass('is-selected');
		$cover.addClass('is-selected');
	});

	// w.addEventListener('resize', throttle(setRevealAlignMiddle, 50, 100));

	// =================================================
	// 預設語系
	// const nowLang = $('html').attr('lang');
	// if (nowLang === 'he') {
	// 	$('.ft-country__selected').val('Israel');
	// }

	// // 切換語系
	// $(document).on('change', '.js-country__selected', function () {
	// 	const $option = $(this).find('option:selected');
	// 	const urlPath = $option.attr('data-lang');

	// 	window.location.href = urlPath;
	// });

	// =================================================
})(jQuery, window, document);
